import { DropdownMenuSubContent as SDropdownMenuSubContent } from '@/components/ui/dropdown-menu';
import { ReactNode } from 'react';

export function DropdownMenuSubContent({ children }: { children: ReactNode }) {
  return (
    <SDropdownMenuSubContent
      sideOffset={10}
      className="max-h-64 overflow-scroll">
      {children}
    </SDropdownMenuSubContent>
  );
}
